import { AnyAction } from 'redux'
import { LoadMainTopicsParams, LoadReferenceSourceRatingParams } from '../../api/domain/usecases/summary-service'
import * as actionType from './types'
import { summaryService } from '../../api'


export const setTopicsList = (list:any): AnyAction => ({ type: actionType.SUMMARY_SET_TOPICS_LIST, payload: list })
export const setEventTopicsList = (list: any): AnyAction => ({ type: actionType.SUMMARY_SET_EVENT_TOPICS_LIST, payload: list })
// export const setReferenceSourceRatingList = (list): AnyAction => ({ type: actionType.SUMMARY_SET_REFERENCE_SOURCE_RATING_LIST, payload: list })

export const fetchTopicsList = (type: 'smi' | 'social', period: 'day' | 'week' | 'month', from: string, to: string, referenceFilter: number[]) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_TOPICS_START })
  const { app } = getState()

  const params: LoadMainTopicsParams = {
    threadId: app.thread.id,
    referenceFilter,
    period,
    type,
    start: 0,
    limit: 20,
    from,
    to
  }

  summaryService.loadMainTopics(params)
    .then(resp => {
      dispatch(setTopicsList(resp))
      dispatch({ type: actionType.SUMMARY_FETCH_TOPICS_SUCCESS })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_TOPICS_FAIL, payload: error.message })
    })
}

export const fetchEventTopicsList = (type: 'smi' | 'social', period: 'day' | 'week' | 'month', from: string, to: string, referenceFilter: number[]) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_EVENT_TOPICS_START })
  const { app } = getState()

  const params: LoadMainTopicsParams = {
    threadId: app.thread.id,
    referenceFilter,
    period,
    type,
    start: 0,
    limit: 20,
    from,
    to
  }

  summaryService.loadMainTopics(params)
    .then(resp => {
      dispatch(setEventTopicsList(resp))
      dispatch({ type: actionType.SUMMARY_FETCH_EVENT_TOPICS_SUCCESS })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_EVENT_TOPICS_FAIL, payload: error.message })
    })
}

export const fetchReferenceSourceRatingList = (type: 'smi' | 'social', period: 'day' | 'week' | 'month', from: string, to: string) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_START })
  const { app, user } = getState()

  const params: LoadReferenceSourceRatingParams = {
    threadId: app.thread.id,
    referenceId: app.references.subject.id,
    period,
    type,
    userId: user.uid,
    from,
    to
  }

  summaryService.loadReferenceSourceRating(params)
    .then(resp => {
      // dispatch(setReferenceSourceRatingList(resp))
      // let list = resp.filter(it => it.sources[type].length !== 0).sort((a, b) => b.mentions - a.mentions)
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_SUCCESS, payload: resp.filter(it => it.sources !== 0).sort((a, b) => b.sources - a.sources) })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_RATING_FAIL, payload: error.message })
    })
}

export const fetchReferenceSourceTopicsList = (type: 'smi' | 'social', period: 'yesterday' | 'day' | 'week' | 'month', from: string, to: string, referenceId: number) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_START })
  const { app, user } = getState()

  const params: LoadReferenceSourceRatingParams = {
    threadId: app.thread.id,
    referenceId,
    period,
    type,
    userId: user.uid,
    from,
    to
  }

  summaryService.loadReferenceSourceTopics(params)
    .then(resp => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_SUCCESS, payload: resp })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_FAIL, payload: error.message })
    })
}

export const fetchCurrentSmiParams = (params: any) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_START })

  
  summaryService.loadCurrentSmiParams(params)
    .then(resp => {
      console.log('dfdf222', resp)
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_SUCCESS, payload: resp })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_THEMES_FAIL, payload: error.message })
    })
}

export const fetchReferenceSourceTopicsRubricList = (type: 'smi' | 'social', period: 'day' | 'week' | 'month', from: string, to: string, referenceId: number) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_START })
  const { app, user } = getState()

  const params: LoadReferenceSourceRatingParams = {
    threadId: app.thread.id,
    referenceId,
    period,
    type,
    userId: user.uid,
    from,
    to
  }

  summaryService.loadReferenceSourceTopics(params)
    .then(resp => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_SUCCESS, payload: resp })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_RUBRIC_FAIL, payload: error.message })
    })
}

export const fetchReferenceSourceTopicsSphereList = (type: 'smi' | 'social', period: 'day' | 'week' | 'month', from: string, to: string, referenceIds: number[], referenceItemId?: number) => async (dispatch: any, getState: any) => {
  dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_START })
  const { app, user } = getState()

  const params: LoadReferenceSourceRatingParams = {
    threadId: app.thread.id,
    referenceId: referenceIds,
    referenceItemId,
    period,
    type,
    userId: user.uid,
    from,
    to
  }

  summaryService.loadReferenceSourceTopics(params)
    .then(resp => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_SUCCESS, payload: resp })
    })
    .catch(error => {
      dispatch({ type: actionType.SUMMARY_FETCH_REFERENCE_SOURCE_TOPICS_DIGEST_SPHERE_FAIL, payload: error.message })
    })
}
